import io from "socket.io-client";

export const socket = io('https://classicdice.xanhchin.io');
